export default __webpack_public_path__ + "static/media/Elimina.a3029825.svg";